import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'Index',
      component: () => import('../views/Index.vue'),
      meta:{
        title: '启明星商城'
      }
    },
    {
      path: '/member_sub',
      name: 'MemberSub',
      component: () => import('../views/MemberSub.vue'),
      meta:{
        title: '我的服务'
      }
    },
    {
      path: '/order',
      name: 'order',
      // route level code-splitting
      // this generates a separate chunk (order.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/order.vue'),
      meta:{
        title: '我的订单'
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      // route level code-splitting
      // this generates a separate chunk (orderDetail.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/orderDetail.vue'),
      meta:{
        title: '订单详情'
      }
    },
    {
      path: '/product_info',
      name: 'ProductInfo',
      component: () => import('../views/ProductInfo.vue'),
      meta:{
        title: '启明星商城'
      }
    },{
      path: '/product_info_loding',
      name: 'ProductInfoLoding',
      component: () => import('../views/ProductInfoLoding.vue'),
      meta:{
        title: '启明星商城'
      }
    },
    {
      path: '/pay',
      name: 'Pay',
      component: () => import('../views/Pay.vue'),
      meta:{
        title: '支付'
      }
    },
    {
      path: '/forward',
      name: 'Forward',
      component: () => import('../views/Forward.vue'),
      meta:{
        title: '支付'
      }
    },
    {
      path: '/xieyi',
      name: 'xieyi',
      component: () => import('../views/xieyi.vue'),
      meta:{
        title:'启明星投顾值服务协议'
      }
    }, {
      path: '/smrz',
      name: 'Smrz',
      component: () => import('../views/Smrz.vue'), 
      meta:{
        title: '实名认证'
      }
    }, {
      path: '/fxcp',
      name: 'fxcp',
      component: () => import('../views/Fxcp.vue'),
      meta:{
        title: '风险测评'
      }
    }, {
      path: '/fxts',
      name: 'fxts',
      component: () => import('../views/Fxts.vue'),
      meta:{
        title: '风险提示'
      }
    }, {
      path: '/fxtss',
      name: 'fxtss',
      component: () => import('../views/fxtss.vue'),
      meta: {
        title: '风险提示书'
      }
    },
    {
      path: '/tgfwxy',
      name: 'tgfwxy',
      component: () => import('../views/tgfwxy.vue'),
      meta: {
        title: '投顾服务协议'
      }
    },
    {
      path: '/sdxpg',
      name: 'sdxpg',
      component: () => import('../views/sdxpg.vue'),
      meta: {
        title: '适当性评估'
      }
    },{
      path: '/myCoupon',
      name: 'myCoupon',
      component: () => import('../views/myCoupon.vue'),
      meta: {
        title: '我的优惠券'
      }
    }
    ,{
      path: '/morePay',
      name: 'morePay',
      component: () => import('../views/MorePay.vue'),
      meta: {
        title: '支付'
      }
    },{
      path: '/GetCoupon',
      name: 'GetCoupon',
      component: () => import('../views/GetCoupon.vue'),
      meta: {
        title: '领券中心'
      }
    },{
      path: '/GetCoupon1',
      name: 'GetCoupon1',
      component: () => import('../views/GetCoupon1.vue'),
      meta: {
        title: '领券中心'
      }
    },{
      path: '/paysuccess',
      name: 'paysuccess',
      component: () => import('../views/paysuccess.vue'),
      meta: {
        title: '支付'
      }
    },{
      path: '/loding',
      name: 'loding',
      component: () => import('../views/loding.vue'),
      meta: {
        title: '支付'
      }
    },{
      path: '/contract',
      name: 'contract',
      component: () => import('../views/contract.vue'),
      meta: {
        title: '合同'
      }
    },{
      path: '/smrzHg',
      name: 'smrzHg',
      component: () => import('../views/smrzHg.vue'),
      meta: {
        title: '实名认证'
      }
    }
  ,{
    path: '/contractHg',
    name: 'contractHg',
    component: () => import('../views/contractHg.vue'),
    meta: {
      title: '电子签章'
    }
  }
  ,{
    path: '/fxcpHg',
    name: 'fxcpHg',
    component: () => import('../views/FxcpHg.vue'),
    meta: {
      title: '风险测评'
    }
  },{
    path: '/member',
    name: 'member',
    component: () => import('../views/member.vue'),
    meta: {
      title: '我的会员'
    }
  },{
    path: '/cs',
    name: 'cs',
    component: () => import('../views/cs.vue'),
    meta: {
      title: '我的会员'
    }
  },{
    path: '/tishi',
    name: 'tishi',
    component: () => import('../views/tishi.vue'),
    meta: {
      title: '提示'
    }
  }
    
    
  ]
  
const router = new VueRouter({
  mode: 'history',
  base: 'mall',
  routes
})

export default router
